import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import customStyles from './selectStyle'
import styles from './styles.module.css'

import 'prismjs/themes/prism-tomorrow.css'

const Container = ({ children, className, sticky = false }) => {
  const [languages, setLanguages] = useState([])
  const [responses, setResponses] = useState([])
  const [activeLanguage, setActiveLanguage] = useState({ label: '', value: '' })
  const [activeResponse, setActiveResponse] = useState({ label: '', value: '' })

  useEffect(() => {
    const langs = []
    const responses = []
    children.forEach(child => {
      if (child.props && child.props.language) {
        langs.push(child.props.language)
      }
    })
    children.forEach(child => {
      if (child.props && child.props.response) {
        responses.push(child.props.response)
      }
    })
    setLanguages(langs)
    setResponses(responses)
    setActiveLanguage({ label: langs[0], value: langs[0] })
    setActiveResponse({ label: responses[0], value: responses[0] })
  }, [children])

  const renderSelector = (options, active, changeFunc) => () => {
    return (
      <Select
        components={{
          IndicatorSeparator: () => null,
        }}
        data-testid="sample-code-select"
        onChange={option => changeFunc(option)}
        options={options.map(opt => ({ value: opt, label: opt }))}
        styles={customStyles}
        value={active}
      />
    )
  }

  const renderChild = (kind, options, active, changeFunc) => {
    return children.map(child => {
      if (child.props && child.props[kind] === active.value) {
        return React.cloneElement(child, {
          renderOptions: renderSelector(options, active, changeFunc),
        })
      }
      return null
    })
  }

  const renderChildren = () => {
    if (responses.length) {
      return renderChild(
        'response',
        responses,
        activeResponse,
        setActiveResponse
      )
    }
    return renderChild('language', languages, activeLanguage, setActiveLanguage)
  }

  return (
    <div
      className={`${sticky && styles.sticky} ${className}`}
      data-testid="sample-code-container"
    >
      {renderChildren()}
    </div>
  )
}

export default Container
